<script setup>
import { inject, computed } from "vue";

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});

const accordion = inject("accordion");

const isOpen = computed(() =>
    accordion.openItems.value.includes(props.id)
);

const toggle = () => {
  accordion.toggleItem(props.id);
};
</script>


<template>
  <div class="box-style">
    <slot :isOpen="isOpen" :toggle="toggle" />
  </div>
</template>

<style scoped>
.box-style {
  border: 1px solid #E2E2E4;
  background-color: #ffffff;
  border-radius: 0.375rem;
  overflow: hidden;
}
</style>